import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1200px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 10px;
    }
  }

  .filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    align-items: flex-end;
  }

  /* Estilo Padronizado de Listagem */
  .contracts-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 0 5px;
  }

  .contract-card {
    background: #fff;
    padding: 15px 25px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1fr 150px;
    gap: 15px;
    align-items: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    width: 100%;

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(3px);
    }

    @media (max-width: 1100px) {
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      flex-direction: column;
      strong {
        font-size: 15px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        font-size: 11px;
        color: #008037;
        font-weight: bold;
      }
    }

    .info-item {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      color: #666;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        margin-bottom: 2px;
      }
      span {
        font-weight: 500;
      }
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;

      button {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;
      }
    }
  }
`;

export const Boxs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0px 0 20px 0;
  gap: 10px;

  div {
    background: #f0f0f0;
    min-width: 150px;
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    border-radius: 50px;
    justify-content: center;
    padding: 10px 15px;
    border: 2px solid transparent;
    cursor: pointer;
    transition: all 0.2s;

    &.active {
      border-color: #363636;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    p {
      width: 100%;
      font-size: 12px;
      text-align: center;
      font-weight: 600;
      color: #000;
      margin: 0;
    }
  }
`;
